"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSunFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("circle", { cx: 15.96, cy: 15.99, r: 8 }),
        React.createElement("path", { d: "M14.958 1l2-.018.035 4-2 .017zM4.659 6.12L6.06 4.694l2.854 2.803-1.402 1.426zM.99 15.03l4-.034.018 2-4 .035zM4.709 25.924l2.804-2.853 1.426 1.402-2.803 2.853zM15.005 26.998l2-.018.035 4-2 .018zM23.068 24.484l1.401-1.427 2.854 2.803-1.402 1.427zM26.99 14.994l4-.035.017 2-4 .035zM23.067 7.515l2.803-2.853 1.427 1.402-2.804 2.853z" })));
}
exports.default = SvgSunFilled;
//# sourceMappingURL=SunFilled.js.map